import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { courseTypeOptions } from "../../../../utils/const";
import { Message } from "primereact/message";
import { useAxios, API_URL } from "../../../../utils/const";
import excelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

const RekapModal = ({
  toggleModal,
  setCourseType,
  courseType,
  setFromDate,
  fromDate,
  setToDate,
  toDate,
  courseId,
}) => {
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      courseType: {
        value: courseType,
        label: courseType == "" ? "-- PILIH SALAH SATU --" : courseType,
      },
      fromDate: fromDate,
      toDate: toDate,
    },
  });
  const axiosInstance = useAxios();
  const toDateInput = watch("toDate");

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const formatDate = (isoDate) => {
    // Format using moment
    return moment(isoDate).format("DD MMM YYYY");
  };

  const handleExportExcel = async (formData) => {
    setLoading(true);

    try {
      setCourseType(formData.courseType.value);
      setFromDate(formData.fromDate);
      setToDate(formData.toDate);

      const data = {
        courseType: formData.courseType.value,
        fromDate: formData.fromDate,
        toDate: formData.toDate,
      };

      const result = await axiosInstance.post(
        `${API_URL}/course-sessions/rekap/${courseId}`,
        data
      );

      const timetables = result.data.data.courseGroupTimetables;

      console.log("Response", timetables);

      const workbook = new excelJS.Workbook();

      timetables.forEach((timetable, index) => {
        let sheetName =
          timetable.course_type + " " + timetable.date.slice(0, 10);
        let count = 1;

        // Tambah angka kalau ada yang sama
        while (workbook.worksheets.some((sheet) => sheet.name === sheetName)) {
          sheetName = `${timetable.course_type} ${timetable.date.slice(
            0,
            10
          )} ${count}`;
          count++;
        }
        const sheet = workbook.addWorksheet(sheetName);

        // Baris #1
        if (timetable.course_type.includes("TUTORIAL (SESI 1)")) {
          sheet.mergeCells("A1:G1");
        } else if (timetable.course_type.includes("TUTORIAL (SESI 2)")) {
          sheet.mergeCells("A1:H1");
        } else if (timetable.course_type.includes("KKD")) {
          sheet.mergeCells("A1:G1");
        } else {
          sheet.mergeCells("A1:F1");
        }
        const titleRow = sheet.getRow(1);
        titleRow.getCell(
          1
        ).value = `REKAP KEHADIRAN ${timetable.courseGroup.course.name.toUpperCase()}`;

        sheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // Baris #2
        if (timetable.course_type.includes("TUTORIAL (SESI 1)")) {
          sheet.mergeCells("A2:G2");
        } else if (timetable.course_type.includes("TUTORIAL (SESI 2)")) {
          sheet.mergeCells("A2:H2");
        } else if (timetable.course_type.includes("KKD")) {
          sheet.mergeCells("A2:G2");
        } else {
          sheet.mergeCells("A2:F2");
        }
        const dateRow = sheet.getRow(2);
        dateRow.getCell(1).value = `${formatDate(timetable.date)} - (${
          timetable.start_time
        } - ${timetable.end_time})`;

        sheet.getRow(2).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // Baris #3
        if (timetable.course_type.includes("TUTORIAL (SESI 1)")) {
          sheet.mergeCells("A3:G3");
        } else if (timetable.course_type.includes("TUTORIAL (SESI 2)")) {
          sheet.mergeCells("A3:H3");
        } else if (timetable.course_type.includes("KKD")) {
          sheet.mergeCells("A3:G3");
        } else {
          sheet.mergeCells("A3:F3");
        }
        const lecturerRow = sheet.getRow(3);
        lecturerRow.getCell(
          1
        ).value = `${timetable.lecturers[0].lecturer.name.toUpperCase()} (${
          timetable.lecturers[0].check_in ?? "-"
        } - ${timetable.lecturers[0].check_out ?? "-"})`;

        sheet.getRow(3).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // Baris #4
        const headerRow = sheet.addRow([
          "No",
          "NIM",
          "NAMA MAHASISWA",
          "WAKTU HADIR",
          ...(timetable.course_type.includes("SESI 1") ? ["NILAI PROSES"] : []),
          ...(timetable.course_type.includes("SESI 2")
            ? ["NILAI PROSES", "NILAI LOGBOOK"]
            : []),
          ...(timetable.course_type.includes("KKD") ? ["NILAI PROSES"] : []),
          "KETERANGAN",
          "STATUS",
        ]);

        headerRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        sheet.columns = [
          { key: "no", width: 5 },
          { key: "nim", width: 15 },
          { key: "nama_mahasiswa", width: 25 },
          { key: "waktu_hadir", width: 20 },
          ...(timetable.course_type.includes("SESI 1")
            ? [{ key: "nilai_proses", width: 15 }]
            : []),
          ...(timetable.course_type.includes("SESI 2")
            ? [
                { key: "nilai_proses", width: 15 },
                { key: "nilai_logbook", width: 15 },
              ]
            : []),
          ...(timetable.course_type.includes("KKD")
            ? [{ key: "nilai_proses", width: 15 }]
            : []),
          { key: "keterangan", width: 30 },
          { key: "status", width: 15 },
        ];

        // Row 5 dst
        timetable.students.forEach((student, index) => {
          const status =
            student.status === 1
              ? "TEPAT WAKTU"
              : student.status === 2
              ? "TERLAMBAT"
              : "TIDAK HADIR";

          let logbookScore;
          let prosesScore;
          let formattedLogbookScore;
          let formattedProsesScore;
          let kkdScore;
          let formattedKkdScore;
          if (timetable.course_type.includes("TUTORIAL")) {
            logbookScore =
              student.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialLogbookScore?.find(
                (score) => score.student_id === student.student.id
              )?.final_score;

            prosesScore =
              student.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialPenilaianProses?.find(
                (score) => score.student_id === student.student.id
              )?.final_score;

            formattedLogbookScore = logbookScore
              ? parseFloat(logbookScore).toFixed(1)
              : "-";

            formattedProsesScore = prosesScore
              ? parseFloat(prosesScore).toFixed(1)
              : "-";
          }

          if (timetable.course_type.includes("KKD")) {
            kkdScore =
              student.courseGroupTimetableKkd?.kkdPenilaianProses?.find(
                (score) => score.student_id === student.student.id
              )?.final_score;
            formattedKkdScore = kkdScore
              ? parseFloat(kkdScore).toFixed(1)
              : "0";
          }

          const dataRow = sheet.addRow({
            no: index + 1,
            nim: student.student.nim,
            nama_mahasiswa: student.student.name,
            waktu_hadir: student.check_in || "-", // Default to "-" if null
            ...(timetable.course_type.includes("SESI 1") && {
              nilai_proses: formattedProsesScore,
            }),
            ...(timetable.course_type.includes("SESI 2") && {
              nilai_proses: formattedProsesScore,
              nilai_logbook: formattedLogbookScore,
            }),
            ...(timetable.course_type.includes("KKD") && {
              nilai_proses: formattedKkdScore,
            }),
            keterangan: student.description || "-",
            status,
          });

          let fontColor;
          if (status === "TEPAT WAKTU") {
            fontColor = "00B050"; // Hijau
          } else if (status === "TERLAMBAT") {
            fontColor = "FFBF00"; // Kuning-Oranye
          } else if (status === "TIDAK HADIR") {
            fontColor = "FF0000"; // Merah
          }

          // Terapkan gaya pada setiap sel dalam baris
          dataRow.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            if (
              (timetable.course_type.includes("TUTORIAL") && colNumber === 8) ||
              (timetable.course_type.includes("KKD") && colNumber === 7) ||
              (!timetable.course_type.includes("TUTORIAL") &&
                !timetable.course_type.includes("KKD") &&
                colNumber === 6)
            ) {
              cell.font = {
                color: { argb: fontColor },
              };
            }
          });
        });
      });

      // 🔹 Simpan Workbook ke File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Rekap_Course.xlsx");

      console.log("Excel berhasil dibuat!");

      setLoading(false);
      closeModal();
    } catch (error) {
      console.log("Error:", error);
      setLoading(false);
      closeModal();
    }
  };

  return (
    <Modal show={toggleModal} onHide={closeModal} size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Rekap Absensi</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* COURSE TYPE */}
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Tipe Pertemuan</label>
              <Controller
                control={control}
                name="courseType"
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={courseTypeOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">
          {/* FROM DATE */}
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Dari Tanggal</label>
              <input
                {...register("fromDate", {
                  required:
                    toDateInput !== "" ? "Kolom ini wajib diisi" : false,
                })}
                type="date"
                className="form-control"
              />
              {errors.fromDate && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.fromDate.message}
                  />
                </div>
              )}
            </div>
          </div>

          {/* TO DATE */}
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Sampai Tanggal</label>
              <input
                {...register("toDate")}
                type="date"
                className="form-control"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleExportExcel)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Filter</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RekapModal;
